import React, { useState, useEffect } from 'react'


const PatternItem = (props) => {
    
    let icon = <path d="M26.6808 0C23.0391 0.00339618 19.8691 2.31295 17.6728 4.99239C16.8228 6.02955 15.1225 8.10393 15.1225 8.10393C15.1083 7.6548 15.0802 7.16492 14.9936 6.8561C14.0921 3.63907 10.6759 1.31137 7.34482 1.52016C4.86477 1.67483 2.1977 2.80582 0.830848 4.94857C-0.70897 7.36263 0.150129 10.4662 1.3212 12.8764C3.51815 17.399 7.53409 20.5749 10.5109 24.5227C12.3411 26.9498 12.9443 29.9823 13.9056 32.7999C13.8526 33.6309 14.6123 33.6568 14.3245 32.9333C14.2258 31.549 14.7158 30.175 15.1499 28.8703C16.1433 25.8845 17.9887 23.2318 20.4221 21.2337C23.8802 18.3945 28.223 16.7627 31.2815 13.4193C33.6455 10.8346 35.0182 6.72098 33.0782 3.61609C31.6235 1.28806 28.9595 -0.00204288 26.681 8.37677e-05L26.6808 0Z"  />;

    switch (props.icon) {
        case "cloud":
            icon = <path d="M12.3749 36C10.3601 35.9974 8.42292 35.2226 6.96202 33.835C5.50112 32.4475 4.62761 30.5528 4.52124 28.5408C4.41488 26.5288 5.08374 24.5525 6.39021 23.0187C7.69667 21.4848 9.54135 20.5101 11.5447 20.295C10.9548 17.9818 11.308 15.5289 12.5266 13.4761C13.7452 11.4233 15.7294 9.93865 18.0427 9.34878C20.3559 8.7589 22.8087 9.11212 24.8616 10.3307C26.9144 11.5493 28.399 13.5335 28.9889 15.8468C30.3647 15.6552 31.7651 15.7488 33.1032 16.1216C34.4412 16.4945 35.6882 17.1387 36.7666 18.0142C37.8451 18.8896 38.7318 19.9776 39.3717 21.2104C40.0117 22.4433 40.3911 23.7946 40.4864 25.1803C40.5817 26.5661 40.3908 27.9566 39.9257 29.2655C39.4606 30.5743 38.7311 31.7734 37.7827 32.7883C36.8343 33.8031 35.6872 34.612 34.4128 35.1645C33.1384 35.717 31.7639 36.0014 30.3749 36H12.3749Z"  />
            break;
        case "leaf":
            icon = <path d="M8.53019 35C5.98157 34.8165 4.64917 33.8864 3.96484 32.8542C4.096 30.3414 4.47602 27.2117 5.544 24.3713C6.15627 22.7448 7.02517 21.2724 8.09108 20.19C9.25651 18.8998 10.3334 17.9071 11.4184 17.0885C13.5601 15.4826 15.4389 14.783 16.0335 14.5369C16.635 14.302 17.7133 13.8605 19.0182 13.3688C20.319 12.9178 21.8945 12.2652 23.2393 11.4673C25.9964 9.94099 28.2817 8.21857 28.278 8.21794C28.2826 8.21857 25.8393 9.58959 23.0003 10.7276C21.5678 11.3458 20.1043 11.7522 18.7382 12.0723C17.394 12.4224 16.2586 12.7788 15.6333 13.0237C14.4642 13.5178 7.45963 15.787 3.88188 23.3937C3.07261 25.3366 2.56505 27.3464 2.23636 29.2297C1.4276 28.7675 0.420799 27.8731 0.146544 26.2177C-0.331455 23.3335 -0.0654962 14.6791 7.68101 9.87145C15.4281 5.06443 24.0772 6.0252 28.2163 4.61536C32.355 3.20551 34 0 34 0C34 0 30.5508 32.6281 8.53019 35Z"  />
            break;
        case "off":
            icon = <path  fill="none"  strokeWidth="2" d="M 36.06,1.06 C 36.06,1.06 1.06,36.06 1.06,36.06M 22.00,4.50 C 26.69,4.50 30.50,8.31 30.50,13.00 30.50,13.00 30.50,22.00 30.50,22.00 30.50,26.69 26.69,30.50 22.00,30.50 22.00,30.50 14.00,30.50 14.00,30.50 9.31,30.50 5.50,26.69 5.50,22.00 5.50,22.00 5.50,13.00 5.50,13.00 5.50,8.31 9.31,4.50 14.00,4.50 14.00,4.50 22.00,4.50 22.00,4.50 Z" />
            break;
        case "on":
            icon = <path fill="none"  strokeWidth="2" d="M 18.00,1.50 C 22.69,1.50 26.50,5.31 26.50,10.00 26.50,10.00 26.50,19.00 26.50,19.00 26.50,23.69 22.69,27.50 18.00,27.50 18.00,27.50 10.00,27.50 10.00,27.50 5.31,27.50 1.50,23.69 1.50,19.00 1.50,19.00 1.50,10.00 1.50,10.00 1.50,5.31 5.31,1.50 10.00,1.50 10.00,1.50 18.00,1.50 18.00,1.50 Z" />
            break;
        default:
            break;
    }

    let tmpCSS = `stroke-current fill-current ${(props.select ? props.selectedColor : props.color)} ${(props.pulse? ' animate-pulse' : '')}`
    
    return (
        <>
            <svg className={tmpCSS} onClick={props.onClick} data-value={props.value} width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                {icon}
            </svg>
        </>
    )
}

PatternItem.defaultProps = {
    color: 'text-white',
    selectedColor: 'text-green-600'
}



const Color = (props) => {

    return (
        <div className={`rounded-full h-6 w-6 items-center justify-center ${props.color} border-2 border-gray-400 ${props.select ? 'ring ring-black ring-offset-4' : ''}`}
            onClick={props.onClick} data-value={props.value} ></div>
    )
}


const Select = (props) => {

    const [selected, setSelected] = useState(props.default)
    
    const [pulse, setPulse] = useState(false)
    let timer;
    const selectClickHandler = ev => {
        clearTimeout(timer);
        setSelected(ev.currentTarget.dataset.value)
        setPulse(ev.currentTarget.dataset.value)
        console.log(ev.currentTarget.dataset.value);
        if(props.updateEvent){
               
                props.updateEvent(ev.currentTarget.dataset.value)
                console.log("VALL" ,ev.currentTarget.dataset.value);
                timer = setTimeout(() => {  setPulse(false) }, 2000);

        }
    }

    useEffect(() => {
        // "timer" will be undefined again after the next re-render
        return () => clearTimeout(timer);
      }, [timer]);

    const childrenWithProps = React.Children.map(props.children, child => {
        // Checking isValidElement is the safe way and avoids a typescript
        // error too.
        if (React.isValidElement(child)) {
            return React.cloneElement(child, { onClick: selectClickHandler, select: (selected === child.props.value), pulse: (pulse === child.props.value) });
        }
        return child;
    });

    return (<>
        <div className="flex space-x-10 justify-self-center pl-10">
            {childrenWithProps}
        </div>
    </>)
}

export default Select;
export {  Color, PatternItem }